import { render } from "./WebSpreed.vue?vue&type=template&id=0c47de9c&scoped=true"
import script from "./WebSpreed.vue?vue&type=script&lang=js"
export * from "./WebSpreed.vue?vue&type=script&lang=js"

import "./WebSpreed.vue?vue&type=style&index=0&id=0c47de9c&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-case/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c47de9c"]])

export default __exports__